<template>
  <form @submit.prevent="editWeeklyTask">
    <div class="flex">
      <div class="mb-4 p-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">DETYRAT JAVORE</label>
        <input
          class="shadow appearance-none border rounded w-64 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          v-model="weeklyTask.name"
          required
        />
      </div>
      <div class="mb-4 p-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">KOMENT</label>
        <textarea
          class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="weeklyTask.comment"
        ></textarea>
      </div>
      <div class="mb-4 p-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="zv3">ZV3</label>
        <input
          type="text"
          class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="weeklyTask.zv3" />
      </div>
      <div class="mb-4 p-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">ZGJEDH DITET:</label>

        <multiselect
          v-model="value"
          :options="options"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="ZGJEDH DITET"
          label="name"
          track-by="name"
          :preselect-first="true"
          class="border block text-gray-700 text-sm mb-2"
        >
          <template slot="selection" slot-scope="{ values, isOpen }">
            <span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
            >{{ values.length }} options selected</span>
          </template>
        </multiselect>
      </div>
      <div class="mb-4 p-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">AM/PM</label>
        <div class="relative">
          <select
            class="shadow appearance-none border rounded w-auto py-2 px-5 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            v-model="weeklyTask.time"
          >
            <option>AM</option>
            <option>PM</option>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div class="pt-4" v-if="isAdmin">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">Zgjedhe User-in:</label>
        <div class="inline-block relative">
          <select
            class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
            v-model="user"
          >
            <option>Zgjedh</option>
            <option v-for="(user, id) in users" :value="user.id" :key="id">{{ user.name }}</option>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div class="mb-4 pt-12">
        <div class="p-1">
          <button
            type="submit"
            class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          >Ndrysho</button>
        </div>
        <div class="p-1">
          <router-link
            to="/excel#friday"
            class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
          >Kthehu</router-link>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      weeklyTask: {},
      id: this.$route.params.id,
      value: [],
      options: [
        { name: "E HENE", value: "Monday" },
        { name: "E MARTE", value: "Tuesday" },
        { name: "E MERKURE", value: "Wednesday" },
        { name: "E ENJTE", value: "Thursday" },
        { name: "E PREMTE", value: "Friday" }
      ],
      user: null,
      users: [],
      isAdmin: false
    };
  },
  created() {
    this.getUsers();
    this.getWeeklyTask();
  },
  methods: {
    getUsers() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios.get(`${process.env.VUE_APP_API}/user`).then(response => {
        if (response.data.data.is_admin) {
          this.isAdmin = true;
        } else {
          this.isAdmin = false;
        }
      });

      axios
        .get(`${process.env.VUE_APP_API}/excel/users`)
        .then(response => {
          this.users = response.data;
          // console.log(this.users);
        })
        .catch(error => console.log(error));
    },
    getWeeklyTask() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(`${process.env.VUE_APP_API}/excel/detyrat-javore/${this.id}`)
        .then(response => {
          // console.log(response);
          this.weeklyTask = response.data;
          this.value = response.data.days;
          console.log(this.value);
        })
        .catch(error => console.log(error));
    },
    editWeeklyTask() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .put(`${process.env.VUE_APP_API}/excel/detyrat-javore/${this.id}`, {
          name: this.weeklyTask.name,
          comment: this.weeklyTask.comment,
          days: this.value,
          time: this.weeklyTask.time,
          zv3: this.weeklyTask.zv3
        })
        .then(() => {
          this.$notify({
            group: "address",
            title: "Detyra",
            text: "Detyra u ndryshua"
          });

          this.$router.push("/excel");
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style></style>
